import React from 'react';

export default function TableDecorateText(props) {
    return <section className="d-flex flex-row align-items-center">
        <span className="tutee-list--list__name" {...props} />
    </section>
}